<div class="topic-banner no-dorder-bottom">
  <div class="container">
    <div class="topic-img-bg">
      <img src="{{ env.IMGIX_UPLOADS_URL }}static/shared/CAREERS_new.jpg" alt="CAREERS_new" class="img-responsive" />
    </div>
  </div>
</div>

<div class="static-page-text">
  <div class="container">
    <div class="page-title-header">
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <div class="page-title text-center">
            <h1>{{ 'CAREERS' | translate }}</h1>
            <h3>{{ 'career_intro1' | translate }} .</h3>
          </div>
        </div>
        <div class="col-md-6">
          <p>{{ 'career_intro2' | translate }} .</p>
        </div>

        <div class="col-md-6">
          <p>{{ 'career_intro3' | translate }} .</p>
        </div>
      </div>
    </div>
    <div class="discover-opt">
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <div class="page-title text-center">
            <h2>{{ 'DISCOVER OUR OPPORTUNITIES' | translate }}</h2>
          </div>
        </div>
      </div>
      <div class="table-opportunities">
        <table class="table">
          <thead>
            <tr>
              <th>{{ 'Position' | translate }}</th>
              <th>{{ 'Department' | translate }}</th>
              <th>{{ 'Location' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <a href="{{ env.IMGIX_UPLOADS_URL }}static/docs/06_2024_Operations_Intern.pdf">Operations Intern</a>
              </td>
              <td><a href="{{ env.IMGIX_UPLOADS_URL }}static/docs/06_2024_Operations_Intern.pdf">Operations</a></td>
              <td><a href="{{ env.IMGIX_UPLOADS_URL }}static/docs/06_2024_Operations_Intern.pdf">Copenhagen</a></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
